module.exports = __webpack_public_path__ + "img/norway.a187f5d7.jpg";